export default __webpack_public_path__ + "assets/images/4543a9b123b9a4bc9675e01383cc6682-nat-avatar.png";